/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Role_EditorInputs */



/**
* | output |
* | --- |
* | "Editor" |
*
* @param {Team_Manager_Role_EditorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_role_editor = /** @type {((inputs?: Team_Manager_Role_EditorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Role_EditorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Éditeur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Editor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Redattore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактор")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エディタ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editor")
	return /** @type {LocalizedString} */ ("Editor")
});